import React from 'react';
import { connect } from 'react-redux';

import * as reservationActions from '../../../redux/reservations/actions';
import submitForm from '../../../utils/submitForm';
import enums from '../../../enums';

import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

import InvoiceDetailsModal from '../modals/InvoiceDetails';
import ReserveDetailsModal from '../modals/ReserveDetails';
import ReservesReportTable from './Table';
import ReservesReportFilter from './Filter';

class ReserveReportList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      itemsPerPage: 20,
      query: '',
      sortType: 'asc',
      sortBy: 'createdAt',
      sortedColumn: '',
      errorText: locales('errors.default'),
      errorFlag: false,
      selectedReserveId: -1,
      reserveDetailsModalIsOpen: false,
      invoiceModalIsOpen: false,
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  displayReserveDetailsModal = id => {
    const selectedReserve = this.props.cafeReservationsList.filter(
      reserve => reserve.id == id,
    )[0];

    if (selectedReserve) {
      this.setState(() => ({
        reserveDetailsModalIsOpen: true,
        selectedReserveId: selectedReserve.id,
      }));
    }
  };

  closeReserveDetailsModal = () => {
    this.setState(() => ({
      reserveDetailsModalIsOpen: false,
      selectedReserveId: null,
    }));
  };

  displayInvoiceModal = id => {
    const selectedReserve = this.props.cafeReservationsList.filter(
      reserve => reserve.id == id,
    )[0];

    if (selectedReserve) {
      this.setState(() => ({
        invoiceModalIsOpen: true,
        selectedReserveId: selectedReserve.id,
      }));
    }
  };

  closeInvoiceModal = () => {
    this.setState(() => ({
      invoiceModalIsOpen: false,
      selectedReserveId: null,
    }));
  };

  renderStatusColors = status => {
    const {
      AUTO_APPROVED,
      WAITING,
      STARTED,
      APPROVED,
      REJECTED,
      UNPAID,
      FINISHED,
      CANCELED,
    } = enums.CAFE_RESERVATION.values;

    switch (status) {
      case AUTO_APPROVED:
        return 'text-info';
      case WAITING:
        return 'text-warning';
      case STARTED:
        return 'card-text-success';
      case APPROVED:
        return 'text-success';
      case REJECTED:
        return 'text-danger';
      case UNPAID:
        return 'text-muted';
      case FINISHED:
        return 'card-text-navy';
      case CANCELED:
        return 'card-text-blue';
      default:
        return 'text-dark';
    }
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.actions.fetchAllCafeReservations(query);
    });
  };

  applyFilters = event => {
    const queryString = submitForm(event);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;

    if (sort && filter) {
      query = `${filter}&${sort}`;
    } else if (filter) {
      query = `${filter}`;
    } else if (sort) {
      query = `${sort}`;
    }

    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.actions.fetchAllCafeReservations(searchQuery);
    });
  };

  sortTable = query => {
    const sortType = this.state.sortType == 'asc' ? 'desc' : 'asc';

    this.setState({ sortedColumn: query, sortType }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  render() {
    const {
      cafeReservationsList = [],
      loading,
      error,
      message,
      failed,
    } = this.props;
    const { totalRecords } = this.props.cafeReservations;

    return (
      <Spin spinning={loading}>
        <section className='page-header'>
          <h1>{locales('titles.reservationInvoices')}</h1>
        </section>

        {this.state.errorFlag && this.handleAlert()}

        {error && (
          <div className='alert alert-danger'>
            {locales('messages.server.error')}
          </div>
        )}
        {failed && <div className='alert alert-danger'>{message}</div>}

        <section className='panel panel-default'>
          <div className='panel-heading'>
            <i className='fas fa-list-alt px-1' />
            {locales('titles.reserves.list')}
          </div>

          <div className='panel-body'>
            <ReservesReportFilter
              applyFilters={this.applyFilters}
              filterAndSort={this.filterAndSort}
            />

            <ReservesReportTable
              data={cafeReservationsList}
              itemsPerPage={this.state.itemsPerPage}
              currentPage={this.state.currentPage}
              sortedColumn={this.state.sortedColumn}
              sortType={this.state.sortType}
              renderStatusColors={this.renderStatusColors}
              displayReserveDetailsModal={this.displayReserveDetailsModal}
              // displayInvoiceModal={this.displayInvoiceModal}
            />

            <div className='pagination-container'>
              <Pagination2
                totalRecords={totalRecords || 0}
                pageLimit={this.state.itemsPerPage}
                pageNeighbours={2}
                onPageChanged={this.onPageChanged}
                currentPage={this.state.currentPage}
              />
            </div>
          </div>
        </section>

        {this.state.reserveDetailsModalIsOpen && (
          <ReserveDetailsModal
            isOpen={this.state.reserveDetailsModalIsOpen}
            reserveId={this.state.selectedReserveId}
            close={this.closeReserveDetailsModal}
          />
        )}

        {this.state.invoiceModalIsOpen && (
          <InvoiceDetailsModal
            isOpen={this.state.invoiceModalIsOpen}
            close={this.closeInvoiceModal}
            getInvoiceDataByReserveId={
              this.props.actions.getInvoiceDataByReserveId
            }
            getReservationTemporaryPrint={
              this.props.actions.getReservationTemporaryPrint
            }
            getReservationFactorPrint={
              this.props.actions.getReservationFactorPrint
            }
            getReservationTemporaryPrintByPrinterTarget={
              this.props.actions.getReservationTemporaryPrintByPrinterTarget
            }
            totalEntranceAmount={
              this.props.reservationInvoiceDetails.totalEntranceAmount
            }
            // getMyCafeMenuItems={this.getMyCafeMenuItems}
            // temproraySave={this.props.temproraySaveInvoice}
            // finalSave={this.props.finalSaveInvoice}
            invoiceData={this.props.reservationInvoiceDetails}
            fetchDataLoading={this.props.reservationInvoiceDetailsLoading}
            fetchDataMessage={this.props.reservationInvoiceDetailsMessage}
            fetchDataFailed={this.props.reservationInvoiceDetailsFailed}
            fetchDataError={this.props.reservationInvoiceDetailsError}
            // menuItemsList={this.props.menuItemsList}
            // getMenuItemsLoading={this.props.getMenuItemsLoading}
            // getMenuItemsMessage={this.props.getMenuItemsMessage}
            // getMenuItemsFailed={this.props.getMenuItemsFailed}
            // getMenuItemsError={this.props.getMenuItemsError}

            // temporarySaveLoading={this.props.temporarySaveInoviceItemsLoading}
            // temporarySaveFailed={this.props.temporarySaveInoviceItemsFailed}
            // temporarySaveError={this.props.temporarySaveInoviceItemsError}
            // temporarySaveMessage={this.props.temporarySaveInoviceItemsMessage}

            // finalSaveLoading={this.props.finalSaveInoviceItemsLoading}
            // finalSaveFailed={this.props.finalSaveInoviceItemsFailed}
            // finalSaveError={this.props.finalSaveInoviceItemsError}
            // finalSaveMessage={this.props.finalSaveInoviceItemsMessage}
            reservationTemporaryReceipt={this.state.reservationTemporaryReceipt}
            reservationFactorPrint={this.state.reservationFactorPrint}
            reserveId={this.state.selectedReserveId}
            cafeName={this.props.reservationInvoiceDetails.cafeName}
            invoiceId={this.props.reservationInvoiceDetails.id}
            invoiceNo={this.props.reservationInvoiceDetails.num}
            customerFullName={
              this.props.reservationInvoiceDetails.customerFullName
            }
            customerMobileNumber={
              this.props.reservationInvoiceDetails.customerMobileNumber
            }
            individualsCount={
              this.props.reservationInvoiceDetails.reservePersons
            }
            tablesNum={this.props.reservationInvoiceDetails.reservedTables}
            meal={this.props.reservationInvoiceDetails.reserveMeal}
            reserveDate={this.props.reservationInvoiceDetails.reserveDate}
            reserveStartAt={this.props.reservationInvoiceDetails.reserveStartAt}
            reserveEndAt={this.props.reservationInvoiceDetails.reserveEndAt}
            reserveStatus={this.props.reservationInvoiceDetails.reserveStatus}
            invoiceStatus={this.props.reservationInvoiceDetails.invoiceStatus}
            trackingNumber={
              this.props.reservationInvoiceDetails.reserveTrackingNumber
            }
            reserveType={this.props.reservationInvoiceDetails.reserveType} // TODO
            subTotalPrice={this.props.reservationInvoiceDetails.subTotalPrice}
            toBePaidToCafePrice={
              this.props.reservationInvoiceDetails.toBePaidToCafePrice
            }
            hourlyDiscountAmount={
              this.props.reservationInvoiceDetails.hourlyDiscountAmount
            }
            hourlyDiscountPercent={
              this.props.reservationInvoiceDetails.hourlyDiscountPercent
            }
            discountCodeAmount={
              this.props.reservationInvoiceDetails.discountCodeAmount
            }
            discountCodePercent={
              this.props.reservationInvoiceDetails.discountCodePercent
            } // TODO
            totalPrice={this.props.reservationInvoiceDetails.totalPrice}
            reserveBaseCost={
              this.props.reservationInvoiceDetails.reserveBaseCost
            }
            currency={this.props.reservationInvoiceDetails.currency} // TODO
            invoiceAdditions={
              this.props.reservationInvoiceDetails.invoiceAdditions
            } // TODO
            invoiceAdditionsAmount={
              this.props.reservationInvoiceDetails.invoiceAdditionsAmount
            } // TODO
            invoiceItems={this.props.reservationInvoiceDetails.invoiceItems} // TODO
            // menuItems={this.props.reservationInvoiceDetails.menuItems} // TODO
            notes={this.props.reservationInvoiceDetails.notes}
            rseePercent={this.props.reservationInvoiceDetails.rseePercent}
            rseeStockAmount={
              this.props.reservationInvoiceDetails.rseeStockAmount
            }
            balanceAmount={this.props.reservationInvoiceDetails.balanceAmount}
            invoiceDiscountCodeAmount={
              this.props.reservationInvoiceDetails.invoiceDiscountCodeAmount
            }
          />
        )}
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    cafeReservationsList: state.reservationsReducer.cafeReservationsList,
    cafeReservations: state.reservationsReducer.cafeReservations,
    loading: state.reservationsReducer.cafeReservationsLoading,
    error: state.reservationsReducer.cafeReservationsError,
    message: state.reservationsReducer.cafeReservationsMessage,
    failed: state.reservationsReducer.cafeReservationsFailed,

    reservationInvoiceDetails:
      state.reservationsReducer.reservationInvoiceDetails,
    reservationInvoiceDetailsLoading:
      state.reservationsReducer.reservationInvoiceDetailsLoading,
    reservationInvoiceDetailsMessage:
      state.reservationsReducer.reservationInvoiceDetailsMessage,
    reservationInvoiceDetailsFailed:
      state.reservationsReducer.reservationInvoiceDetailsFailed,
    reservationInvoiceDetailsError:
      state.reservationsReducer.reservationInvoiceDetailsError,

    reservationTemporaryReceipt:
      state.reservationsReducer.reservationTemporaryReceipt,
    reservationFactorPrint: state.reservationsReducer.reservationFactorPrint,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      fetchAllCafeReservations: query =>
        dispatch(reservationActions.fetchAllCafeReservations(query)),
      getInvoiceDataByReserveId: reserveId =>
        dispatch(reservationActions.fetchReservationInvoiceDetails(reserveId)),
      getReservationTemporaryPrint: (reserveId, printMode) =>
        dispatch(reservationActions.fetchReservationTemporaryPrint(reserveId, printMode)),
      getReservationFactorPrint: reserveId =>
        dispatch(reservationActions.fetchReservationFactorPrint(reserveId)),
      getReservationTemporaryPrintByPrinterTarget: (reserveId, printerTarget) =>
        dispatch(
          reservationActions.fetchReservationTemporaryPrintByPrinterTarget(
            reserveId,
            printerTarget,
          ),
        ),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReserveReportList);
